firebird.controller('meetingEndedCtrl', [
    '$rootScope',
    'meetingService',
    '$window',
    function ($rootScope, meetingService, $window) {
        var self = this;

        self.title = '';

        init();

        ////////////////////////

        function init() {
            //jquery hack for hiding the loading spinner during XHR requests
            $window.$('body > #loading-bar-spinner').hide();

            self.title = meetingService.getTitle();

            // Exit compact mode if meeting ends while in compact mode layout
            $rootScope.$broadcast('enable-compact-mode', false);
        }
    }
]);
